import * as stylex from '@stylexjs/stylex';
import './drawer-scrollbar.css';
import { typography } from '@shared/tokens/typography.stylex';
import { colors } from '@shared/tokens/colors.stylex';

export const styles = stylex.create({
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: 99,
    opacity: 0,
    pointerEvents: 'none',
    transition: 'opacity 0.3s ease',
    border: 'none',
    padding: 0,
    margin: 0,
    cursor: 'pointer',
    font: 'inherit',
    color: 'inherit',
  },
  overlayVisible: {
    opacity: 1,
    pointerEvents: 'all',
  },
  drawer: {
    position: 'fixed',
    top: 0,
    height: '100%',
    backgroundColor: colors.primaryBackground,
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
    zIndex: 100,
    transition: 'left 0.3s ease, right 0.3s ease',
    transform: 'translateX(0%)',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  drawerLeft: {
    left: '-100%',
  },
  drawerLeftVisible: {
    left: '0%',
  },
  drawerRight: {
    right: '-100%',
  },
  drawerRightVisible: {
    right: '0%',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  },
  title: {
    margin: 0,
    fontSize: typography['fontSizeBody-1'],
    lineHeight: typography['lineHeightBody-1'],
  },
  closeButton: {
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: 0,
  },
  content: {
    flex: 1,
    overflowY: 'auto',
    padding: '0 4px 0 0',
    display: 'flex',
    flexDirection: 'column',
  },
});
